import { render, staticRenderFns } from "./LocalityForm.vue?vue&type=template&id=8a7cd81e&"
import script from "./LocalityForm.vue?vue&type=script&lang=js&"
export * from "./LocalityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports